import { t } from "@/lib/i18n";

const stamp = (d) => d.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
const esc = (t = "") => t.replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");

const eventData = (c) => {
  const start = new Date(c.appointment.at);
  const end = new Date(start.getTime() + 60 * 60 * 1000);
  return {
    start,
    end,
    title: t("cal.title", { t: c.title.slice(0, 60) }),
    place: c.appointment.place || "",
    details: t("cal.details", { folio: c.folio, title: c.title }),
  };
};

export const downloadIcs = (c) => {
  const e = eventData(c);
  const mins = c.appointment.reminder_minutes || 1440;
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Aclarate//Asistente Ciudadano MX//ES",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:${c.folio}@aclarate.mx`,
    `DTSTAMP:${stamp(new Date())}`,
    `DTSTART:${stamp(e.start)}`,
    `DTEND:${stamp(e.end)}`,
    `SUMMARY:${esc(e.title)}`,
    `LOCATION:${esc(e.place)}`,
    `DESCRIPTION:${esc(e.details)}`,
    "BEGIN:VALARM",
    "ACTION:DISPLAY",
    `DESCRIPTION:${esc(t("cal.reminder", { t: e.title }))}`,
    `TRIGGER:-PT${mins}M`,
    "END:VALARM",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
  const url = URL.createObjectURL(new Blob([ics], { type: "text/calendar;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `cita-${c.folio}.ics`;
  a.click();
  URL.revokeObjectURL(url);
};

export const googleCalendarUrl = (c) => {
  const e = eventData(c);
  const p = new URLSearchParams({ action: "TEMPLATE", text: e.title, dates: `${stamp(e.start)}/${stamp(e.end)}`, details: e.details, location: e.place });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
};
